<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("notice.标题") }}</th>
            <th>{{ $t("notice.发布日期") }}</th>
            <th>{{ $t("notice.状态") }}</th>
            <th>{{ $t("notice.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id" :id="item.id">
            <td>{{ item.title }}</td>
            <td>{{ item.timeCreated | formatDate }}</td>
            <td>{{ status[item.ifRead] }}</td>
            <td>
              <a
                class="tx-info"
                href="javascript:;"
                @click="openNoticeView(item.id)"
                >{{ $t("app.查看详情") }}</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  data() {
    return {
      status: {
        1: this.$t("notice.已读"),
        2: this.$t("notice.未读"),
      },
    };
  },
  filters: {
    formatDate(val) {
      if (!val) return "----";
      return moment(val, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD");
    },
  },
  methods: {
    /**
     * 打开详情模态框
     */
    openNoticeView(id) {
      this.$emit("openNoticeView", id);
    },
  },
};
</script>
